import { useEffect, useLayoutEffect } from 'react';

/**
 * Prevents React from warning when calling useLayoutEffect during server-rendering.
 */
export const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
    ? useLayoutEffect
    : useEffect;
